import {ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {AccountModel} from "../../models/account.model";

require('./demand-account-item.scss');
@Component({
  standalone: false,
  selector: 'app-demand-account-item',
  templateUrl: './demand-account-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandAccountItemComponent {

  @Input() account: AccountModel;
  @Output() selectAccount = new EventEmitter<AccountModel>();

  onSelectAccount(account: AccountModel) {
    this.selectAccount.emit(account);
  }

}
